import React from 'react';
import { Globe, GraduationCap, ShieldCheck, BadgeDollarSign } from 'lucide-react';

const REASONS = [
  {
    icon: Globe,
    title: "World's most influential B2B audience",
    body: "LinkedIn has crossed 1 billion users, X is where founders and operators argue ideas in real time, and the top B2B newsletters reach 250K+ engaged decision-makers per send.",
    tint: 'from-[#FF4343]/15 to-transparent',
    border: 'border-[#FF4343]/30',
  },
  {
    icon: GraduationCap,
    title: 'Pre-qualified, high-intent buyers',
    body: '1 in 3 LinkedIn users hold a bachelor degree or higher and at least half have HHI > $75K (Statista). On X and newsletters the audience is even more concentrated by role and stage.',
    tint: 'from-[#FFA500]/10 to-transparent',
    border: 'border-yellow-500/30',
  },
  {
    icon: ShieldCheck,
    title: 'Trust beats interruption',
    body: 'People trust people, not logos. A real exec or creator vouching in their voice lands harder than any ad — and the platforms are the cleanest, most brand-safe environments in social.',
    tint: 'from-[#10B981]/10 to-transparent',
    border: 'border-emerald-500/30',
  },
  {
    icon: BadgeDollarSign,
    title: 'Better economics than ads',
    body: 'Average LinkedIn ad CPM is $33.80 and rising. A single endorsement post from an exec in your ICP reaches the right buyers organically, gets shared, and lives forever — no escalating ad spend, no expiring impressions.',
    tint: 'from-[#9333EA]/10 to-transparent',
    border: 'border-purple-500/30',
  },
];

export default function WhyChannel() {
  return (
    <section className="py-24 sm:py-32 border-t border-white/5 bg-[#0B1138]" data-testid="why-channel-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-14 sm:mb-20 max-w-3xl mx-auto">
          <p className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#FF4343] mb-3">★ Why this channel ★</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
            Why exec &amp; creator <span className="text-[#FF4343]">marketing</span>.
          </h2>
          <p className="text-sm sm:text-base text-[#9CA3AF] leading-relaxed">
            People trust people, not brands. Exec &amp; creator marketing on LinkedIn, X, and newsletters
            lets B2B brands reach their actual buyers and build trust faster than any paid channel can.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {REASONS.map((r, i) => (
            <div key={i} data-testid={`why-channel-card-${i}`}
              className={`relative bg-[#111827] border ${r.border} p-6 sm:p-8 hover:-translate-y-0.5 transition-all overflow-hidden`}>
              <div className={`absolute inset-0 bg-gradient-to-br ${r.tint} opacity-60 pointer-events-none`} aria-hidden />
              <div className="relative">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#090E33] border border-white/10 flex items-center justify-center mb-5">
                  <r.icon className="w-6 h-6 sm:w-7 sm:h-7 text-[#FF4343]" />
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-3 leading-snug">{r.title}</h3>
                <p className="text-xs sm:text-sm text-[#9CA3AF] leading-relaxed">{r.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
